import { useRef } from "react";

interface QueryErrorMetadata {
  component: string;
  action: string;
}

export const toError = (value: unknown): Error | null => {
  if (value === null || value === undefined) return null;
  if (value instanceof Error) return value;
  return new Error(String(value));
};

export const reportQueryError = (
  error: Error,
  metadata: QueryErrorMetadata
): void => {
  window.newrelic?.noticeError(error, {
    component: metadata.component,
    action: metadata.action,
  });
};

export const useShouldThrowQueryError = (
  error: Error | null,
  metadata: QueryErrorMetadata
): void => {
  const lastReportedErrorRef = useRef(false);

  if (!error) {
    lastReportedErrorRef.current = false;
    return;
  }

  if (!lastReportedErrorRef.current) {
    lastReportedErrorRef.current = true;
    reportQueryError(error, metadata);
  }

  throw error;
};
